import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

export const Datenschutz = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Simple Header */}
      <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-200">
        <div className="container mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/" className="text-2xl font-bold text-gray-900">
            SafeTec<span className="text-blue-600">+</span>
          </Link>
          <Link to="/">
            <Button variant="outline" size="sm">
              <ArrowLeft className="mr-2 h-4 w-4" />
              Zurück
            </Button>
          </Link>
        </div>
      </header>

      {/* Content */}
      <div className="container mx-auto px-4 py-16 max-w-4xl">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Datenschutzerklärung</h1>

        <div className="prose prose-gray max-w-none">
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Kontaktdaten des Verantwortlichen</h2>
            <p className="text-gray-700 leading-relaxed">
              <strong>Name:</strong> Sebastian Schaper (Datenschutzbeauftragter)<br />
              <strong>HS Hanse Trade KG</strong><br />
              Oldachstrasse 32<br />
              22307 Hamburg<br />
              <strong>Telefon:</strong> +49 174 2619596<br />
              <strong>E-Mail:</strong> anfrage@safetec-plus.de
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Verwendung Ihrer Daten</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Alle Zugriffe auf unsere Homepage und Abrufe von dort gespeicherten Dateien werden protokolliert. Diese Speicherung dient internen systembezogenen und statistischen Zwecken. Erfasst werden Zeit und Dauer, die IP-Adresse des anfragenden Rechners, Browsertyp/Browserversion, Referrer URL, das verwendete Betriebssystem sowie die besuchten Seiten innerhalb unserer Präsentation. Die Erhebung, Speicherung, Nutzung und Übermittlung Ihrer Daten erfolgt im Rahmen des Bundesdatenschutzgesetzes. Wir behandeln Ihre persönlichen Daten streng vertraulich und daher ist eine Übermittlung an unberechtigte Dritte grundsätzlich ausgeschlossen.
            </p>

            <h3 className="text-xl font-bold text-gray-900 mb-3 mt-6">Kontaktaufnahme</h3>
            <p className="text-gray-700 leading-relaxed mb-4">
              Wenn Sie mit uns per E-Mail Kontakt aufnehmen, werden die von Ihnen an uns mit Ihrer E-Mail übermittelten personenbezogenen Daten gespeichert. Außerdem halten wir auf unserer Internetseite ein Kontaktformular vor. Dabei werden folgende Daten übermittelt und gespeichert:
            </p>
            <ul className="list-disc pl-6 text-gray-700 leading-relaxed mb-4">
              <li>Name</li>
              <li>E-Mail-Adresse</li>
              <li>Telefon</li>
            </ul>
            <p className="text-gray-700 leading-relaxed">
              Die Daten werden ausschließlich zur Beantwortung Ihres Anliegens verwendet. Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f) DSGVO. Die Daten werden vorbehaltlich gesetzlicher Aufbewahrungsfristen gelöscht, sobald wir Ihre Anfrage abschließend bearbeitet haben.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Cookies</h2>
            <p className="text-gray-700 leading-relaxed">
              Die Internetseite verwendet teilweise sogenannte Cookies. Cookies richten auf Ihrem Rechner keinen Schaden an und enthalten keine Viren. Cookies dienen dazu, unser Angebot nutzerfreundlicher, effektiver und sicherer zu machen. Die meisten der von uns verwendeten Cookies sind sogenannte „Session-Cookies". Sie werden nach Ende Ihres Besuchs automatisch gelöscht. Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert werden und Cookies nur im Einzelfall erlauben.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Betroffenenrechte</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Betroffenen Personen stehen hinsichtlich ihrer personenbezogenen Daten folgende Rechte zu: Auskunft (Art. 15 DSGVO), Berichtigung (Art. 16 DSGVO), Löschung (Art. 17 DSGVO), Einschränkung der Verarbeitung (Art. 18 DSGVO), Datenübertragbarkeit (Art. 20 DSGVO) sowie das Recht auf Beschwerde bei einer Aufsichtsbehörde (Art. 77 DSGVO).
            </p>
            <p className="text-gray-700 leading-relaxed mb-2">
              <strong>Die zur Geltendmachung vorgenannter Rechte zuständige Stelle:</strong>
            </p>
            <p className="text-gray-700 leading-relaxed">
              Sebastian Schaper<br />
              HS Hanse Trade KG<br />
              Oldachstrasse 32<br />
              22307 Hamburg<br />
              Telefon: +49 174 2619596<br />
              E-Mail: anfrage@safetec-plus.de
            </p>
          </section>

          <section className="mb-8">
            <p className="text-gray-700 leading-relaxed text-sm">
              <strong>Stand:</strong> 19. März 2026
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-200">
          <Link to="/">
            <Button className="bg-blue-600 hover:bg-blue-700">
              <ArrowLeft className="mr-2 h-4 w-4" />
              Zurück zur Startseite
            </Button>
          </Link>
        </div>
      </div>

      {/* Simple Footer */}
      <footer className="bg-gray-900 text-white py-8 mt-16">
        <div className="container mx-auto px-4 text-center">
          <p className="text-gray-400 text-sm">
            © 2025 SafeTec+ | HS Hanse Trade KG | Hamburg
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Datenschutz;
